import { Box, FormControlLabel, styled } from '@mui/material';

/** 레거시 .pledge-form */
export const NewCardPledgeBox = styled(Box)`
  padding: 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 2px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  font-size: 14px;
  line-height: 20px;

  & .pledge-title {
    display: block;
    font-size: 16px;
    font-weight: 500;
  }
  & ol {
    margin: 10px 0 0;
    padding-left: 18px;
    list-style: decimal;
  }
  & ol li {
    margin-top: 8px;
  }
  & ol li:first-of-type {
    margin-top: 0;
  }
`;

/** 레거시 .agree-chk-area — 안내 문구 왼쪽, 라디오 오른쪽 */
export const NewCardAgreeRow = styled(Box)`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 4px 12px;
  margin-top: 10px;
`;

export const NewCardAgreeAlert = styled('p')`
  margin: 0;
  font-size: 12px;
  color: var(--dk-danger, #f55060);
`;

/** 레거시 .card-type-list li label — 선택 시 파란 테두리·배경 */
export const CardTypeOption = styled(FormControlLabel)`
  gap: 8px;
  margin: 0;
  padding: 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 2px;
  background-color: var(--dk-bg, #fff);
  transition: border-color 0.2s, background-color 0.1s;

  &:hover,
  &:has(input:checked) {
    border-color: #0066cc;
  }
  &:has(input:checked) {
    background-color: #ebf3fb;
  }
  & .MuiFormControlLabel-label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
  }
  & .MuiRadio-root {
    padding: 0;
  }
`;

/** 레거시 view .auth-required-notice */
export const AuthNotice = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 2px;
  background-color: #f3f5f6;
  font-size: 14px;
  line-height: 20px;
  color: var(--dk-text, #000);
`;

export const AuthFileLink = styled('a')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--dk-link, #0066cc);
  text-decoration: underline;
  word-break: break-all;
`;

export const AuthFileHint = styled('span')`
  color: var(--dk-link, #0066cc);
`;

/** 필수 소제목 — 공통 Label 의 필수 점(::after) 그대로 */
export const RequiredSectionTitle = styled('h3')`
  margin: 0;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: var(--dk-text, #131313);

  &::after {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    margin: 4px 4px 0;
    border-radius: 2px;
    background: #f55060;
    vertical-align: top;
  }
`;

export const SectionHint = styled('p')`
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 18px;
  color: var(--dk-text-secondary, #888d96);
`;

export const VerifiedText = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 6px;
  font-size: 12px;
  color: #43b16f;
`;

/** 레거시 .text-link — 평소 본문색 밑줄, 올리면 파란색 */
export const NewCardTextLink = styled('a')`
  color: var(--dk-text, #333);
  text-decoration: underline;

  &:hover {
    color: #3498db;
  }
`;
